package org.hs_soft.runmynesto.domain.usecase.product.tab_product_general

import org.hs_soft.runmynesto.domain.model.home.home.data_assistant_logs.DataAssistantLogsModel
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_product_general.GetDataAssistantAnswerRepository


class GetDataAssistantAnswerUseCase
    (private val repository: GetDataAssistantAnswerRepository) {
    suspend operator fun invoke(
        assistant: String,
        email: String,
        question: String,
        userTimezoneOffsetMinutes: Int,
        userIdToken: String,
        cashList:List<Children>?,
        onLogAnswerUpdate: (DataAssistantLogsModel?) -> Unit,
        language: String?,
        userName:String,
        userEmail:String,
        userCompanyName:String
    ): String {
        return repository.getDataAssistantAnswer(
            assistant = assistant,
            email = email,
            question = question,
            userTimezoneOffsetMinutes = userTimezoneOffsetMinutes,
            userIdToken = userIdToken,
            cashList = cashList,
            onLogAnswerUpdate = onLogAnswerUpdate,
            language = language,
            userName = userName,
            userEmail = userEmail,
            userCompanyName = userCompanyName
        )
    }
}